require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./set-up-2222-app-loading.json") })
        }
      }, "path---set-up-2222-app-loading");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---set-up-2222-app-loading!./.cache/json/set-up-2222-app-loading.json
// module id = 409
// module chunks = 231608221292675